import React from 'react';
import {connect} from 'react-redux';
import {Col, Container, Modal, Row} from 'react-bootstrap';
import {equipoActions, utilActions} from '../../_actions';
import {equipoService} from '../../_services';
import {alertConfirm, EquipoDP, infoTablaDefault} from '../../_helpers';
import MaterialTable from 'material-table';
import {Field, Form, Formik} from 'formik';
import InfoEquipoAdm from './forms/InfoEquipoAdm';
import {FormNuevoEquipo} from './forms';
import {empresaActions} from '../../_actions/empresa.actions';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';

const tableRefEquipo = React.createRef();
const _ = require('lodash');

class AdmEquipos extends React.Component {

    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(infoTablaDefault);
    }

    componentDidMount() {
        if (this.props.empresas === undefined) this.props.traerEmpresas();
    }

    state = {
        show: false,
        equipo: {},
        showInfo: false,
        alert: undefined,
        values: {}
    };

    handleShow = () => {
        this.setState({show: true});
    };

    handleClose = () => {
        this.setState({
            show: false, showInfo: false, equipo: {}
        });
        this.actualizar();
    };

    handleMasInfo = (equipo) => {
        this.setState({
            showInfo: true,
            equipo: equipo
        });
    };

    editar = (equipo) => {
        this.setState({
            show: true,
            equipo: equipo
        });
    };

    cerrarAlert = () => {
        this.setState({alert: undefined});
        this.actualizar();
    }

    eliminar = (equipo) => {
        const getAlert = alertConfirm('Confirmar',
            `¿Está seguro que desea eliminar el equipo de este usuario? `,
            'Sí, eliminar',
            'Cancelar',
            this.cerrarAlert,
            () => this.props.eliminarEquipo(equipo, this.cerrarAlert),
            null,
            true
        )

        this.setState({
            alert: getAlert
        });
    };


    actualizar = () => {
        tableRefEquipo.current && tableRefEquipo.current.onQueryChange();
    }

    actualizarPageSize = (newPageSIze) => {
        if (tableRefEquipo.current) {
            tableRefEquipo.current.dataManager.changePageSize(newPageSIze)
        }
    };

    buscarData = (query, completo) => {
        const newThis = this;
        return new Promise((resolve, reject) => {
            let nuevo = {
                infoTabla: {
                    resultadoCompleto: completo,
                    search: query.search,
                    page: query.page,
                    limit: query.pageSize,
                    skip: Math.floor((query.pageSize * query.page)),
                    orderBy: query.orderBy ? query.orderBy : '',
                    order: query.orderDirection ? query.orderDirection : ''
                }
            };

            if (!completo)
                newThis.setState({nuevo: nuevo});

            let dataBusqueda = newThis.state.values ? Object.assign(newThis.state.values, nuevo) : nuevo;

            equipoService.buscarEquipos(dataBusqueda)
                .then(
                    data => {
                        resolve({
                            data: data.listado ? data.listado.listado : [],
                            page: query.page,
                            totalCount: data.listado ? data.listado.total : 0
                        })
                        this.actualizarPageSize(query.pageSize);
                    }
                );
        })
    }

    render() {
        const {empresas} = this.props;

        const header = [
            {title: 'Id', field: 'id'},
            {title: 'Nombre', field: 'nombre'},
            {title: 'Empresa', field: 'empresa.nombre'},
            {title: 'ApiKey', field: 'apikey'},
            {
                title: 'Acciones', field: 'date',
                render: row =>
                    <div>
                        <a data-tip data-for='info' className="btns btns-link"  onClick={() => this.handleMasInfo(row)}>
                        <span className="material-icons text-fucsia">info</span>
                        </a>
                        <ReactTooltip place="bottom" id='info' aria-haspopup='false' >
                        <span>Info equipo</span>
                        </ReactTooltip> 
                        <a data-tip data-for='edit' className="btns btns-link"  onClick={() => this.editar(row)}>
                        <span className="material-icons text-info">create</span>
                        </a>
                        <ReactTooltip place="bottom" id='edit' aria-haspopup='false' >
                        <span>Editar equipo</span>
                        </ReactTooltip>
                        <a data-tip data-for='eliminar' className="btns btns-link"  onClick={() => this.eliminar(row)}>
                        <span className="material-icons text-dark">delete</span>
                        </a>
                        <ReactTooltip place="bottom" id='eliminar' aria-haspopup='false' >
                        <span>Eliminiar</span>
                        </ReactTooltip> 
                    </div>
            }
        ];
        const options = {
            search: true,
            sorting: true
        }
        let inic = {
            id: '',
            empresa: {id: ''}
        }

        return (
            <div className="main-content">
                <Container fluid>
                    <Row className="row mb-5 mt-5">
                        <Col sm={12}>
                            <button className="btns btns-iot text-white" onClick={this.handleShow}>
                                <i className="material-icons-outlined icon-image-preview align-top">contactless</i> Nuevo
                                Equipo
                            </button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="mt-5">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={inic}
                                    onSubmit={(values) => {
                                        this.setState({
                                            values: values
                                        }, this.actualizar);
                                    }}>
                                    {({values, setFieldValue}) => (
                                        <Form>
                                            <Row className="justify-content-center">
                                                <Col lg={6} xs={12}>
                                                    <label htmlFor="Estado">
                                                        ID equipo
                                                    </label>
                                                    <Field name="id"/>
                                                </Col>

                                                <Col xs="6">
                                                    <label className="font-weight-bold"
                                                           htmlFor="asignado">Empresa </label>
                                                    <Select
                                                        isClearable
                                                        isMulti={false}
                                                        value={empresas ? empresas.filter(obj => values.empresa.id == obj.id) : []}
                                                        name={`empresa`}
                                                        getOptionLabel={option => `${option.nombre}`}
                                                        getOptionValue={option => option.id}
                                                        onChange={so => {
                                                            setFieldValue(`empresa`, so ? so : [])
                                                        }}
                                                        isSearchable={true}
                                                        placeholder="Seleccione"
                                                        options={empresas}
                                                    />
                                                </Col>

                                            </Row>
                                            <Row className="justify-content-center mb-4">
                                                <Col xs={12} lg={3}
                                                     className="mt-4 d-flex justify-content-lg-end justify-content-sm-center">
                                                    <button className="btn-block btns-primary btns" type="submit"><i
                                                        className="fas fa-search"></i> Buscar
                                                    </button>
                                                </Col>

                                            </Row>
                                        </Form>

                                    )}
                                </Formik>
                            </div>
                            <hr></hr>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <MaterialTable
                                title='EQUIPOS'
                                tableRef={tableRefEquipo}
                                columns={header}
                                data={query =>
                                    this.buscarData(query, false)
                                }
                                options={options}
                                localization={utilActions.traerPalabrasTabla()}
                                detailPanel={rowData => {
                                    return (
                                        <EquipoDP rowData={rowData} esAdmin={true}/>
                                    )
                                }}
                                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            />
                        </Col>
                    </Row>
                </Container>
                {this.state.showInfo && <Modal show={this.state.showInfo} onHide={this.handleClose}>
                    <Modal.Header className="bg-iot text-white" closeButton>
                        <Modal.Title><span className="material-icons">info</span> Info equipo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InfoEquipoAdm equipo={this.state.equipo} handleClose={this.handleClose}/>
                    </Modal.Body>
                </Modal>}

                {this.state.show &&
                <Modal show={this.state.show} onHide={this.handleClose} className=" modal-dialog-scrollable" size="lg"
                       backdrop="static" keyboard={false}>
                    <Modal.Header className="bg-iot text-white" closeButton>
                        <Modal.Title>Equipo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="th_iot">
                        <FormNuevoEquipo equipo={this.state.equipo} handleClose={this.handleClose}/>
                    </Modal.Body>
                </Modal>}
                {this.state.alert}
            </div>
        );
    }
}

function mapState(state) {
    const {empresas} = state.empresa;
    const {authentication} = state;
    const {user} = authentication;
    return {user, empresas};
}

const actionCreators = {
    eliminarEquipo: equipoActions.eliminarEquipo,
    traerEmpresas: empresaActions.traerEmpresas
}

const connectedAdmEquipos = connect(mapState, actionCreators)(AdmEquipos);
export {connectedAdmEquipos as AdmEquipos};